<template>
  <div class="text-center mt-5">
    <h1><i class="icon-spinner2 spinner h1 text-white"></i></h1>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    created() {
         if(this.$route.query.close) {
            const interval = setInterval(()=>{
              if(Cookies.get('closeAppleAuthTab')){
                  if(Cookies.get('closeAppleAuthTab') == 'true') {
                    clearInterval(interval)
                    Cookies.remove('closeAppleAuthTab')
                    setTimeout(() => window.close() ,800) 
                  }
              } else {
                clearInterval(interval)
                Cookies.remove('closeAppleAuthTab')
                setTimeout(() => window.close() ,800) 
              }
          },1000);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/authorization/AppleAuthRedirect.vue